import React from 'react';

import sample from '@vlabs/shared/assets/images/video-check/sample.svg';
import { Control, FaceSample } from '@vlabs/uikit';

import st from './shared.module.sass';
import type { PersonProps } from './types';

export function Person({
  id,
  statusList,
  checked,
  disabled,
  onChange,
}: PersonProps): React.JSX.Element {
  return (
    <div className={st.Root}>
      <Control.SelectImage
        checked={checked}
        disabled={disabled}
        image={(
          <FaceSample
            size="small"
            src={sample}
          />
        )}
        onChange={onChange}
        value={id}
      />

      <div className={st.IconsRow}>
        {statusList?.map((s) => (
          <React.Fragment key={s.key}>{s}</React.Fragment>
        ))}
      </div>
    </div>
  );
}
